import { selector } from 'recoil'

import imagesState from './images'

export default selector({
  key: 'interacting',
  get: ({ get }) =>
    get(imagesState).some(([, , , { interacting }]) => interacting),
})
